/* @flow */

export function select(selector: string, parent: ?Element): ?HTMLElement {
  return (parent || document).querySelector(selector);
}

export function selectAll(
  selector: string,
  parent: ?Element
): Array<HTMLElement> {
  return [].slice.call((parent || document).querySelectorAll(selector));
}



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/utilities/select.js